// extracted by mini-css-extract-plugin
module.exports = {"tabs_wrap":"styles_tabs_wrap__2CNl7","hide":"styles_hide__3gYOT"};